import dayjs from "dayjs";
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(isSameOrBefore)

const useDates = () => {

    const addDay = (count = 1, format = "MM/DD/YYYY") => {
        return dayjs().add(count, "days").format(format)
    }

    const isBeforeDate = (date) => {
        return date ? dayjs().isSameOrBefore(dayjs(date), 'day') : false
    }

    

    const dataChecher = (data, count = 1, format ="MM/DD/YYYY") => {
        if (!isBeforeDate(data)) {
            return addDay(count, format)
        }
        return data
    }


    return {
        dayjs,
        isBeforeDate,
        addDay,
        dataChecher
    }
}

export default useDates